var React = require('react');

function Text (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.59,54 C43.92,54 56,36.38 56,21.09C56,5.81 36.11,0 21.78,0 C7.45,0 0,11.70 0,27 C0,42.29 15.26,54 29.59,54 Z","id":"Oval","fill":"#FFE5ED","key":0}),React.createElement("g",{"id":"type","transform":"translate(20.000000, 19.000000)","stroke":"#FF0062","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},[React.createElement("polyline",{"id":"Path","points":"0 3 0 0 16 0 16 3","key":0}),React.createElement("line",{"x1":"5","y1":"16","x2":"11","y2":"16","id":"Path","key":1}),React.createElement("line",{"x1":"8","y1":"0","x2":"8","y2":"16","id":"Path","key":2})])]);
}

Text.defaultProps = {"width":"56px","height":"54px","viewBox":"0 0 56 54","version":"1.1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = Text;

Text.default = Text;
